import ApiService from './api.service';

const TagService = {
    // INPUT: 
    // OUTPUT:   Restituisce la lista dei tag presenti
    // CONTESTO: Assegnazione Tag Dottori -- Assegnazione Tag Sondaggi
    getTags: () => ApiService.fetch('tags'),

    // Assegna un tag a un professionista
    assignTag: (therapistId, tagId) => ApiService.fetch('tags/assign', {
        method: 'POST',
        body: JSON.stringify({ therapist_id: therapistId, tag_id: tagId })
    }),

    // Rimuove un tag da un professionista
    removeTag: (therapistId, tagId) => ApiService.fetch('tags/remove', {
        method: 'POST',
        body: JSON.stringify({ therapist_id: therapistId, tag_id: tagId })
    }),

    // Ricerca terapisti per tag
    getTherapistsByTags: (tagIds) => ApiService.fetch('tags/search-therapists', {
        method: 'POST',
        body: JSON.stringify({ tag_ids: tagIds })
    })
};

export default TagService;
